export enum IgnoreTicketStatus {
    "Unreleased",
    "Unscheduled",
}
